import React, { PropsWithChildren } from "react";
import classNames from "classnames";
import BFTickCircleIcon from "../../images/bf-tick-circle.svg";

type ButtonProps = {
  disabled?: boolean;
  completed?: boolean;
} & React.AnchorHTMLAttributes<HTMLAnchorElement>;

export const LargeButton = ({
  className,
  children,
  disabled,
  completed,
  ...props
}: PropsWithChildren<ButtonProps>) => {
  return (
    <a
      className={classNames(
        "p-6 rounded-[10px] text-sm text-center bg-success",
        className,
        {
          "text-white bg-green-500": !disabled,
          "bg-[#F6F6F6] text-grey-lightest pointer-events-none":
            disabled && !completed,
          "pointer-events-none bg-white border border-grey-lighter text-[#323232]":
            completed,
        }
      )}
      {...props}
    >
      {completed ? (
        <div className="flex justify-center items-center gap-4">
          Completed
          <BFTickCircleIcon />
        </div>
      ) : (
        children
      )}
    </a>
  );
};

export const Button = ({
  className,
  children,
  disabled,
  completed,
  ...props
}: PropsWithChildren<ButtonProps>) => {
  return (
    <a
      className={classNames(
        "py-2 px-6 rounded-[10px] text-sm text-center",
        className,
        {
          "text-white bg-green-500": !disabled && !completed,
          "bg-[#F6F6F6] text-grey-lightest pointer-events-none":
            disabled && !completed,
          "pointer-events-none bg-white border border-grey-lighter text-[#323232]":
            completed,
        }
      )}
      {...props}
    >
      {completed ? (
        <div className="flex justify-center items-center gap-4">
          Completed
          <BFTickCircleIcon />
        </div>
      ) : (
        children
      )}
    </a>
  );
};

export const LinkButton = ({
  className,
  children,
  ...props
}: PropsWithChildren<React.AnchorHTMLAttributes<HTMLAnchorElement>>) => {
  return (
    <a
      className={classNames(
        "px-[15px] py-[7px] rounded-[8px] border border-[#E4E4E4]",
        className
      )}
      {...props}
    >
      {children}
    </a>
  );
};

export const SimpleTextButton = ({
  className,
  children,
  ...props
}: PropsWithChildren<React.AnchorHTMLAttributes<HTMLAnchorElement>>) => {
  return (
    <a
      className={classNames(
        "border-b border-[#323232] text-sm cursor-pointer font-semibold pb-2",
        className
      )}
      {...props}
    >
      {children}
    </a>
  );
};
